import { Form, Formik } from "formik";
import TextInput from "../UI/TextInput";
import { object } from "yup";
import useAuthenticatedAxios from "../../hooks/use-authenticated-axios";
import { dateMax } from "../../models/utils";
import DocumentDownloader from "../UI/DocumentDownloader";
import Checkbox from "../UI/Checkbox";
import FormikSubmitButton from "../UI/FormikSubmitButton";
import { useState } from "react";
import { handleAPIError } from "../../utils/index.jsx";
import Callout from "../UI/Callout";
import moment from "moment/moment";
import styles from "./ExportComptableForm.module.css";

export default function ExportComptableForm({ profileBailleurId }) {
  const axios = useAuthenticatedAxios();
  const [error, setError] = useState("");

  async function generateSignedUrl(values, setSignedUrl) {
    try {
      const response = await axios.post(
        `/profiles/${profileBailleurId}/export-comptable`,
        values,
      );
      setSignedUrl(response.data);
    } catch (error) {
      setError(handleAPIError(error));
    }
  }

  const initialValues = {
    debut: moment().startOf("year").subtract(1, "year").format("YYYY-MM-DD"),
    fin: moment().endOf("year").subtract(1, "year").format("YYYY-MM-DD"),
    include_documents: false,
  };
  return (
    <DocumentDownloader>
      {(setSignedUrl) => (
        <Formik
          onSubmit={(values) => generateSignedUrl(values, setSignedUrl)}
          initialValues={initialValues}
          enableReinitialize={true}
          validationSchema={object({
            debut: dateMax().required(
              "La date de début d'exercice est obligatoire",
            ),
            fin: dateMax().required(
              "La date de fin d'exercice est obligatoire",
            ),
          })}
        >
          <Form className={styles.form}>
            <TextInput
              type="date"
              name="debut"
              label={"Début de l'exercice fiscal"}
              marginForm=""
            />
            <TextInput
              type="date"
              name="fin"
              label={"Fin de l'exercice fiscal"}
              marginForm=""
            />
            <Checkbox name="include_documents">
              Inclure les documents (baux des locataires arrivés sur la période
              et justificatifs des écritures)
            </Checkbox>
            <div className={styles.actions}>
              <FormikSubmitButton>Télécharger</FormikSubmitButton>
            </div>
            <Callout variant="danger">{error}</Callout>
          </Form>
        </Formik>
      )}
    </DocumentDownloader>
  );
}
